import { transparentize } from 'polished'
import styled from 'styled-components'

export const ButtonContainer = styled.div`
    position: absolute;
    line-height: 0;
    z-index: 1;
`

export const ColorButton = styled.div`
    width: 32px;
    height: 32px;
`
export const CheckboardContainer = styled.div`
    position: absolute;
    z-index: 0;
    width: 20px;
    height: 20px;
`

export const PickerPreviewBundle = styled.div`
    position: absolute;
    top: 36px;
    left: 0;
    z-index: 144 !important;
    display: flex;
`

export const PickerContainer = styled.div`
    color: var(--gray-800);
    /* z-index: 144 !important; */
    /* position: absolute;
    top: 36px;
    left: 0; */
    z-index: 1;
    border-radius: 4px;
    background: ${({ theme }) => (theme.themeName === 'light' ? theme['gray-0'] : theme['gray-200'])};
    box-shadow: rgba(0, 0, 0, 0.25) 0px 2px 12px;

    > .sketch-picker {
        box-shadow: none !important;

        background: none !important;

        input {
            background: var(--gray-0);
            border: 1px solid var(--gray-400) !important;
            border-radius: 4px;
            box-shadow: none !important;
        }

        input ~ span {
            color: var(--gray-1000) !important;
        }
    }

    > .form-color-picker__clear-button {
        display: flex;
        flex-wrap: wrap;
        gap: 10px;
        align-items: center;
        border-radius: 0px 0px 4px 4px;
        border-top: 1px solid var(--gray-300);
        cursor: pointer;
        font-size: 14px;
        padding: 8px;

        > .color {
            width: 16px;
            height: 16px;
            outline: currentcolor none medium;
            border-radius: 3px;
            box-shadow: rgba(0, 0, 0, 0.15) 0px 0px 0px 1px inset;
        }
    }
`

export const Icon = styled.div`
    border-radius: 50%;
    background: ${({ theme }) => transparentize(0.3, theme['gray-200'])};
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    z-index: 2;
    width: 16px;
    height: 16px;
    bottom: 1px;
    right: 1px;
    .fa-pen {
        font-size: 10px;
    }
`

export const FormColorPickerToggler = styled.span`
    position: relative;
`

export const PreviewContainer = styled.div<{ backgroundColor: string }>`
    height: 356.25px;

    .preview-light {
        padding: 50px 30px 44px 30px;
        height: 50%;
        background-color: #c4c4c4;
    }

    .preview-dark {
        padding: 50px 30px 44px 30px;
        height: 50%;
        background-color: #364159;
    }

    .barrier-preview {
        width: 120px;
        border: 1px solid ${({ backgroundColor }) => backgroundColor};

        .barrier-header {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 4.5px 8px;
            background-color: ${({ backgroundColor }) => backgroundColor};
            color: var(--gray-0);
            height: 19px;
            .header-text {
                font-size: 10px;
                font-family: var(--font-semibold);
            }

            .header-icons {
                display: flex;
                gap: 4px;
                font-size: 10px;
                font-family: var(--font-regular);
            }
        }

        .barrier-content {
            height: 45px;
            padding: 4px 8px 0px 8px;
            &.light {
                background-color: #ffffff;
                color: #172033;
            }
            &.dark {
                color: #ffffff;
                background-color: #172033;
            }
        }
    }
`
